import { SurveyListTable } from '../components/SurveyListTable';

export function SurveysListPage() {
  return <SurveyListTable />;
}
